import React, { useEffect, useState } from 'react';
import { handleUnauthorizedResponse } from '../../api/http';
import PremiumReportingApi from '../../api/PremiumReportingApi';
import { AuthData } from '../../context/auth';
import { PolicyData, withPolicyContext } from '../../context/policy';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../common';
import LargeCenterSpinner from '../LargeCenterSpinner';
import PremiumReportsTable from '../PremiumReportsTable';
import { errorToast } from '../Toast';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
}

const PremiumReportsView = (props: Props) => {
	const { authData, policyData } = props;

	const { policy } = policyData;

	const [premiumReports, setPremiumReports] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		async function getPremiumReports() {
			try {
				const premiumReportsList = await PremiumReportingApi.getPremiumReports(
					authData.auth.authorizationToken,
					policy.locator,
				);
				setPremiumReports(premiumReportsList.data);
			} catch (error) {
				if (await handleUnauthorizedResponse(error, authData)) {
					return;
				}
				errorToast('Failed to fetch premium reports');
			}
			setLoading(false);
		}
		getPremiumReports();
	}, []);

	if (loading) {
		return <LargeCenterSpinner />;
	}

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Premium Reports</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<PremiumReportsTable premiumReports={premiumReports} policy={policy} />
			</StyledSectionContainer>
		</>
	);
};

export default withPolicyContext<Props>(PremiumReportsView);
